<template>
    <div class="box" @scroll="getLoad">
        <div class="time-line">
            <el-timeline :reverse="false">
                <el-timeline-item v-for="(item, index) in list" :key="index">
                    <div class="time">
                        <div>
                            <span class="year">
                                {{ item?.patrolTimeMain.substring(5,10)}}
                            </span>
                        </div>
                        <div class="day">{{  item?.patrolTimeMain.substring(0,4) }}年</div>
                    </div>
                    <div>
                        <div class="list">
                            <div>
                                <span>巡检结果：</span>
                                <span class="list-status">{{ item.patrolStatusName }}</span>
                            </div>
                            <div class="list-worker">
                                <span>巡检员：</span>
                                <span>{{ item.patrolUserName }}</span>
                            </div>
                            <div style="display:flex;flex-wrap:wrap">
                                <div class="list-image" v-for="(itemT,index) in handelUrl(item?.patrolLivestockList[0]?.patrolImg)" :key="index">
                                    <img :src="(itemT)" class="list-image-card" @click="openDig((itemT),1)">
                                </div>
                                <div class="list-image" v-for="(itemT,index) in handelUrl(item?.patrolLivestockList[0]?.patrolVideo)" :key="index">
                                    <video :src="(itemT)"></video>
                                    <i class="el-icon-video-play list-image-pay" @click="openDig((itemT),2)"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
            <div class=loading style='display:block;text-align:center;height:30px;line-height:30px;color: #fff;padding: 10px;'>{{ stopLoding?'已加载全部内容':'加载中...' }}</div>
            <el-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
                <img :src="urlObj.url" v-show="urlObj.type == 1" width="100%">
                <video :src="urlObj.url" controls width="100%" height="500px" v-show="urlObj.type == 2" id="video" muted autoplay></video>
            </el-dialog>
        </div>
    </div>
</template>
   
<script>
import {getFilePath} from '@/utils/format.js'
export default {
    props:{
        stopLoding:{
            type:Boolean,
            default:true
        },
        list:{
            type:Array,
            default:[]
        }
    },
    data() {
        return {
            dialogVisible: false,
            urlObj:{
                url:'',
                type:1
            }
        }
    },
    computed:{
        handelUrl(){
            return (list)=>{
                    return getFilePath(list)
            }
        }
    },
    methods: {
         //实现下拉加载
     getLoad(){
        let boxHeight=document.querySelector('.box').clientHeight
        let scrollHeight =document.querySelector('.box').scrollHeight
        let scrollTop =document.querySelector('.box').scrollTop
       if(scrollHeight<boxHeight+scrollTop+100){
            if(!this.stopLoding){
                this.$emit('getLoad')
            }
   
       }
    },
        handleClose() {
            this.dialogVisible = false
        },
        openDig(url,type) {
            this.dialogVisible = true
            this.urlObj.url=url,
            this.urlObj.type=type

        }
    }
}
</script>
<style>
.time-line .el-dialog__body {
    display: flex !important;
    justify-content: center !important;
}
</style>
<style lang="scss" scoped>
.box {
    height: 100%;
    width: 100%;
    overflow-y: auto;
}

::v-deep .el-timeline-item__tail {
    border-left: 2px dashed #E4E7ED
}


.time-line {
    margin-top: .2rem;
    margin-left: 0.75rem;
}

.list {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 0.15rem;
    color: #FFFFFF;

    &-status {
        color: #85BC3C;
    }

    &-worker {
        margin-top: 0.2rem;

    }

    &-image {
        width: 0.63rem;
        height: 0.63rem;
        border-radius: 0.05rem 0.05rem 0.05rem 0.05rem;
        border: 0.01rem solid #FFFFFF;
        overflow: hidden;
        margin-top: 0.2rem;
        margin-right: 0.1rem;
        position: relative;

        &-pay {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%)
        }

        &-card {
            width: 100%;
            height: 100%;
        }
    }
}

//左侧时间
.time {
    color: #FFFFFF;
    position: absolute;
    left: -0.75rem;
    top: 1px;

    .year {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 700;
        font-size: 0.18rem;
    }

    .day {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 350;
        font-size: 0.15rem;
        color: #FFFFFF;
        margin-top: 0.1rem;
    }
}
</style>